export default class TipoIncidencia {
    constructor($scope,
                $routeParams,
                method,
                tipoIncidenciaService,
                $location,
                $uibModal,
                toastr) {
        this.scope = $scope;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(tipoIncidenciaService);
                break;
            case 'new':
                this.create(tipoIncidenciaService);
                break;
            case 'view':
                this.view($routeParams,
                    tipoIncidenciaService);
                break;
        }
    }

    list(tipoIncidenciaService) {

        let self = this.scope;

        tipoIncidenciaService.getAll().then((resp, err) => {
            self.tiposDeIncidencias = resp.data.message;
        });

        self.getItemPage = (item) => {
            let index = self.tiposDeIncidencias.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, tipoIncidenciaService);
        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoIncidenciaService.delete({_id: id}).then((resp) => {
                    if (resp.data.success === true) {
                        this.toastr.success('Tipo de incidencia eliminada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al eliminar el tipo de incidencia!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };*/

    }

    create(tipoIncidenciaService) {
        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoIncidenciaService.save(this.scope.tipoIncidencia).then((resp) => {
                    this.toastr.success('Tipo de incidencia creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/tipo_incidencia');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear tipo de incidencia!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    view($routeParams,
         tipoIncidenciaService) {

        this.scope.aux = {};
        tipoIncidenciaService.getById({_id: $routeParams.id}).then((resp) => {
            this.scope.tipoIncidencia = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                tipoIncidenciaService.update(this.scope.tipoIncidencia).then((resp) => {
                    this.toastr.success('Tipo de incidencia modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/tipo_incidencia');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el tipo de incidencia!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };

    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Tipo de Incidencia
			      <div class="modal-body">
                		¿Quiere eliminar el Tipo de Incidencia: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.tiposDeIncidencias.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Tipo de incidencia eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el Tipo de Incidencia!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/tipo_incidencia/tipo_incidencia.js